<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="posts.data"
      :server-items-length="posts.meta.total"
      :sort-desc="true"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 50, 100]
      }"
      :options.sync="options"
      :sort-by="'updated_at'"
    >
      <template v-slot:item.updated_at="{ item }">{{
        item.updated_at | dateFormatted
      }}</template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="posts.edit"
          :route-params="{ id: item.id }"
          :text="$t('ITEM.EDIT')"
          icon="mdi-pencil"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'AppContentList',
  components: { ActionSlotComponent },
  filters: {
    dateFormatted(value) {
      if (!value) return '';

      return moment(value).format('DD.MM.YYYY');
    }
  },

  data: () => ({
    unwatch: null,
    posts: { meta: { total: 0 } },
    options: {}
  }),
  computed: {
    loading() {
      return this.$store.getters['loading'];
    },
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.AUTHOR'),
          value: 'author'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.UPDATED_AT'),
          value: 'updated_at'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    },
    params() {
      const options = this.options;

      return {
        page: options.page,
        per_page: options.itemsPerPage,
        sort_by: options.sortBy[options.sortBy.length - 1],
        order_by: options.sortDesc[options.sortDesc.length - 1] ? 'desc' : 'asc'
      };
    }
  },

  watch: {
    options: {
      handler(e) {
        this.setData();
      },
      deep: true
    }
  },

  created() {
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.setData();
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    ...mapActions('posts', ['getPosts']),
    setData() {
      this.getPosts({ params: this.params })
        .then(({ data }) => {
          this.posts = data;
        })
        .catch(error => {
          this.error = error;
        });
    }
  }
};
</script>
